import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { SERVER_URL } from "../../../config";
import { jwtDecode } from 'jwt-decode';
import { faSpinner, faArrowRight, faXmarkCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CountryList from '../../../country.json';
import states from '../../../states.json';
import './Dna.css';
import Assessment from './Assessment';
import ReportProgress from './ReportProgress';
import AssessmentData from './AssessmentData.json';
import Select from 'react-select';
import { useLocation, useSearchParams } from 'react-router-dom';

export default function UserSection3() {
    const location = useLocation();
    const secret = "GDX2025";
    const Emails = "ryvypasa@mailinator.com"
    const encodeCompns = async (testEmail)=>{
        const encoded = btoa(testEmail + secret); 
        const safeQueryParam = encodeURIComponent(encoded);
        console.log(safeQueryParam,'safe query')
    }
    encodeCompns(Emails)
    const[showsuccessPopup,setshowsuccessPopup] = useState(false)
    const [Email, setEmail] = useState('');
    const [statusUpdated, setstatusUpdated] = useState(false);
    const [params] = useSearchParams();
  
    useEffect(() => {
        const token = params.get('dna_token');
        if (token) {
          try {
            const decoded = atob(decodeURIComponent(token));
            console.log(decoded,'decoded')
            const originalEmail = decoded.replace(secret, '');
            setEmail(originalEmail);
          } catch (err) {
            console.error("Failed to decode email", err);
          }
        }
      }, [params]);    

    console.log(Email,'emaillll')
      const checkDetails = async()=>{
        try{
            await axios.get(`${SERVER_URL}/api/v2/checkAccessDetails?email=${Email}`).then((res)=>{
                console.log(res,'res')
                if(res.data.status == true){
                    if(res.data.Assesment_status == 'Updated'){
                        setstatusUpdated(true)
                        setisOpenpopup(false)
                        setTimeout(() => {
                            window.location = "/DNASucess?dna_query=Sucecss#Redirect"
                        }, 500);
                    }
                }
            })
        }catch(err){
            console.error("Failed to decode email", err);
        }
      }
      useEffect(()=>{
        if(Email){
           checkDetails()
        }
      },[Email])
    const genders = [
        { value: "Male", label: "Male" },
        { value: "Female", label: "Female" },
        { value: "Others", label: "Others" },
    ];

    const [formData, setFormData] = useState({
        fullName: '',
        gender: '',
        email: '',
        mobile: '',
        address: '',
        country: '',
        state: '',
        zipCode: '',
        ReferralCode: '',
        assessment_details:'',
    });

    const [errors, setErrors] = useState({});
    const [isSubmit, setIsSubmit] = useState(false);
    const [isASubmit, setIsASubmit] = useState(false);
    const [dnaStatus, setDnaStatus] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [filteredStates, setFilteredStates] = useState(states);
    const playerToken = sessionStorage.getItem('player_token');
    const [isOpenpopup, setisOpenpopup] = useState(true)
    const[FormSaved,setFormSaved] = useState(false)
    const [activeSection, setactiveSection] = useState('div1');
    const [Name, setName] = useState('');
    const [signatureFile, setSignatureFile] = useState(null);

    const [checkboxes, setCheckboxes] = useState([false, false, false]);
    const [hasConsented, setHasConsented] = useState(false);

    const handleActivetab = (tab) => {
        setactiveSection(tab);
    }

    const handleCheckboxChange = (index) => {
        const updated = [...checkboxes];
        updated[index] = !updated[index];
        setCheckboxes(updated);
    };

    const handleConsent = () => {
        if (signatureFile && checkboxes.includes(true)) {
            setHasConsented(true);
            setactiveSection('div2')

        } else {
            toast.error("Please upload Both Signature and check atleast any of the Check boxes.");
        }
    };


    useEffect(() => {
        const isValid = (token) => {
            if (!token) return false;
            try {
                const decoded = jwtDecode(token);
                setFormData(prev => ({ ...prev, email: decoded.email }));
                return decoded.exp * 1000 > Date.now();
            } catch {
                return false;
            }
        };

        const tokenValid = isValid(playerToken);
        setIsLoggedIn(tokenValid);

        if (tokenValid) {
            checkProfile(playerToken);
        }
    }, [playerToken]);

    const checkProfile = async (token) => {
        try {
            const response = await axios.get(`${SERVER_URL}/api/v2/player-profile-dna`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data.status && response.data.msg === 'registered') {
                setDnaStatus(true);
            } else {
                setDnaStatus(false);
            }
        } catch (error) {
            console.error("Error checking profile: ", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value.trimStart() }));

        if (name === 'country') {
            const selectedCountry = value.trim().toLowerCase();

            const filtered = states.filter(state =>
                state.country_name?.trim().toLowerCase() === selectedCountry
            );

            setFilteredStates(filtered);
            setFormData((prev) => ({ ...prev, state: '' }));
        }
    };

    const validateFields = () => {
        const newErrors = {};

        const nameRegex = /^[A-Za-z\s]{2,}$/;
        if (!nameRegex.test(formData.fullName)) {
            newErrors.fullName = "Name must be alphabetic and at least 2 characters.";
        }

        const emojiRegex = /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF])/g;
        const addressRegex = /^[a-zA-Z0-9\s,'\-./#]{5,}$/;

        if (!addressRegex.test(formData.address) || emojiRegex.test(formData.address)) {
            newErrors.address = "Address must be at least 5 characters, contain valid characters, and not include emojis.";
        }

        // const stateRegex = /^[A-Za-z\s]{2,}$/;
        // if (!stateRegex.test(formData.state) || emojiRegex.test(formData.state)) {
        //     newErrors.state = "State must be alphabetic, valid format, and no emojis.";
        // }

        const countryRegex = /^[A-Za-z\s]{2,}$/;
        if (!countryRegex.test(formData.country) || emojiRegex.test(formData.country)) {
            newErrors.country = "Country must be alphabetic, valid format, and no emojis.";
        }

        if (!/^\d{4,10}$/.test(formData.zipCode)) {
            newErrors.zipCode = "Zip code must be between 4 to 10 digits.";
        }

        return newErrors;
    };
    window.addEventListener('load', () => {
        sessionStorage.removeItem('uploads'); 
    });
    const [answers, setAnswers] = useState(() => {
        const initialAnswers = {};
        AssessmentData.forEach(section => {
          section.questions.forEach(q => {
            initialAnswers[q.state_index] = '';
          });
        });
        return initialAnswers;
      });
    const assessmentDoneRef = useRef(false);

    const [assessmentDone, setAssessmentDone] = useState(false);

    // const waitForConsentAndAssessment = () => {
    //     return new Promise((resolve) => {
    //       setisOpenpopup(true);
    //       setactiveSection('div1');
    //       setAssessmentDone(false);
    //       assessmentDoneRef.current = false;
    //       const interval = setInterval(() => {
    //         if (assessmentDoneRef.current) {
    //           clearInterval(interval);
    //           resolve();
    //         }
    //       }, 300);
    //     });
    //   };
      
    //   const handleAssessmentComplete = () => {
    //     setAssessmentDone(true);
    //     handleSubmit()
    //   };
      
    
      useEffect(() => {
        const convertFileToBase64 = async () => {
          if (signatureFile) {
            try {
              const base64 = await getBase64(signatureFile);  
            //   console.log("Base64 Signature:", base64);
              sessionStorage.setItem('uploads',base64)
              setName(base64);  
            } catch (error) {
              console.error("Error converting file to base64:", error);
            }
          }
        };
    
        convertFileToBase64(); 
      }, [signatureFile]); 
      const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
      
          reader.onload = () => {
            console.log("File loaded successfully:", reader.result);
            resolve(reader.result);  
          };
      
          reader.onerror = (error) => {
            console.log("Error reading file:", error);
            reject(error);  
          };
      
          reader.readAsDataURL(file);  
        });
      };
      
      
      console.log(Name,'Naming')

    
    const handleSubmit = async () => {
        setIsASubmit(true);
        const filteredAnswers = {};
        Object.keys(answers).forEach(key => {
          filteredAnswers[key] = answers[key] || '';
        });
          console.log(formData,'data')
          console.log(filteredAnswers,'answers')
        try {
            const payload = {
            Email,
            signature:sessionStorage.getItem('uploads'), 
            filteredAnswers
            };
            const response = await axios.post(`${SERVER_URL}/api/v2/store-dna-data-players`, payload);
            if (response.data.status) {
                toast.success(response.data.msg);
                setTimeout(() => {
                    window.location = "/DNASucess?dna_query=Sucecss#Redirect"
                }, 500);
            }
        } catch (error) {
            console.error("Error storing data: ", error);
            toast.error(error.response?.data?.msg || 'Something went wrong');
            setTimeout(() => {
                window.location.reload()
            }, 500);
            
        }
    };
    const handleAnswerChange = (key, value) => {
        setAnswers(prev => ({ ...prev, [key]: value }));
      };
      
      const handleFileChange = (e) => {
        const selected = e.target.files[0];
    
        if (selected) {
            const fileType = selected.type;
            const fileSize = selected.size; 
            const maxSize = 10 * 1024 * 1024; 
    
            if (fileSize > maxSize) {
                toast.error("File size exceeds 10MB. Please upload a smaller file.");
                return;
            }
            if (fileType.startsWith('image/')) {
                setSignatureFile(selected);
                console.log("Selected Image File:", selected);
            } else if (fileType === 'application/pdf') {
                console.log("Selected PDF File:", selected);
                setSignatureFile(selected); 
            } else if (fileType === 'application/msword' || fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
                console.log("Selected DOC/DOCX File:", selected);
                setSignatureFile(selected); 
            } else {
                toast.error("Please upload a valid file (Image, PDF, or DOC).");
            }
        }
    };
    // const showOverlay = !isLoggedIn || dnaStatus === true;
    const showOverlay = dnaStatus === true;

    // const overlayMessage = !isLoggedIn
    //     ? "Think you know your game? Your DNA might have a few surprises. Register/Login now and let's see what you're built for!"
    //     : dnaStatus === true
    //         ? "All set! We’ll now get to work on your DNA results. Stay tuned for insights made just for you."
    //         : "";
    const overlayMessage = dnaStatus === true
        ? "All set! We’ll now get to work on your DNA results. Stay tuned for insights made just for you."
        : "";
       
        const AllOptionStyle = {
            control: (provided, state) => ({
              ...provided,
              border: '0px',
              backgroundColor: 'rgba(217,217,217,0.2)',
              borderRadius: '30px',
              boxShadow: '0px',
              color: 'white',
              paddingLeft: '8px',
              outline: 'none',
             
            }),
            placeholder: (provided, state) => ({
              ...provided,
              color: 'lightgray',
              fontSize: '16px',
              fontWeight: '600',
            }),
            option: (provided, state) => ({
              ...provided,
              textAlign: 'center',
              backgroundColor: state.isFocused ? '#7336FA' : '#090909',  
              color: '#fff',
              ':active': {
                backgroundColor: '#d3d3d320',
              },
             
            }),
            singleValue: (provided, state) => ({
              ...provided,
              color: '#fff',
            }),
            input: (provided, state) => ({
              ...provided,
              color: '#fff',
            }),
            menu: (provided, state) => ({
              ...provided,
              background: '#000',
            }),
          };


          console.log(answers,'answers')
    return (
        
        <div className='min-h-screen py-10 grid content-center relative'>
            {showOverlay && (
                <div style={{ fontSize: '30px' }} className="absolute inset-0 bg-black/70 backdrop-blur-[2px] z-20 flex items-center justify-center font-semibold text-white text-center px-6">
                    {overlayMessage}
                </div>
            )}

            {isOpenpopup && (
                <div className="fixed inset-0 flex flex-col items-center h-full  md:justify-center bg-[#000] md:bg-[#000]/80 z-100 px-2 py-5 overflow-auto fade-up-slide">
                    <div className='flex justify-between px-4 w-[90%] lg:w-[60%] mb-2 text-lg'>
                     {!FormSaved && !hasConsented ? <> <button className={`${activeSection === 'div1' ? 'font-bold' : ''} ${hasConsented ? 'text-[#7336FA] font-bold' : ''}`} onClick={() => { handleActivetab('div1') }} >Consent Form</button> </> : '' }
                     {!FormSaved && hasConsented && (
                        <button
                            className={`${activeSection === 'div2' ? 'font-bold' : ''}`}
                            onClick={() => {
                            if (activeSection !== 'div2') {
                                handleActivetab('div2');
                            }
                            }}
                        >
                            Complete Assessment
                        </button>
                        )}
                        {!FormSaved && hasConsented && assessmentDone && (
                        <button
                            className={`${activeSection === 'div3' ? 'font-bold' : ''}`}
                            onClick={() => {
                            if (activeSection !== 'div3') {
                                handleActivetab('div3');
                            }else{
                                return
                            }
                            }}
                        >
                        Report in progress
                        </button>
                        )}

                    </div>
                    <div className="bg-[#232323]/95 p-6 w-[90%] lg:w-[60%] rounded-xl shadow-lg mx-auto relative">

                        {activeSection === 'div1' && !FormSaved ? (
                            <div>
                                <h1 className='text-[#5C1FE2] font-bold'>Consent Form</h1>
                                <div className='bg-[#D9D9D9]/10 rounded-xl p-4 mt-1'>
                                    <div className='max-h-[50vh] lg:max-h-[30vh] Terms-scrollbar overflow-y-auto pr-3'>
                                        <h1 className='font-bold'>RESULT OF CHROMOSOMAL ANALYSIS AND PURPOSE OF THE PROCESSING</h1>
                                        <p className='mt-2'>The test result will contain information on genetic variations identified in regions that are related to
                                            the individual's clinical phenotype. Knowledge of these variations is useful to the physician for
                                            management, counseling, prevention, or specific therapies. All information in the report will be taken
                                            from the most up-to-date medical literature with the help of a specialized database.</p>
                                        <p className='mt-2'>In addition, your data will be processed for research and development processes by Transceptar
                                            Technologies.TelAviv, Israel, now or in the future, including for the purpose of improving technology,
                                            recommendation capabilities and other products and services as may be offered by it in the field of
                                            clinical phenotype, only if you consent to it below.</p>
                                        <h1 className='font-bold mt-2'>WHAT DATA WILL BE PROCESSED?</h1>
                                        <p className='mt-2'>The following information will be collected and processed:</p>
                                        <ul className='list-disc pl-3'>
                                            <li>Personal information which may include your name, ID, contact details, and information
                                                needed for data processing;</li>
                                            <li>Your physician;</li>
                                            <li>The results of the genetic variations report specified in this informed consent;</li>
                                            <li>Age, Height, Weight, and a brief paragraph on your medical history from the requesting
                                                physician.</li>
                                        </ul>
                                        <h1 className='font-bold mt-2'>MODALITIES OF PROCESSING</h1>
                                        <p className='mt-2'>Your data will be processed by means of specialized statistical and Machine Learning analysis tools.
                                            In particular, all preventative measures set forth in data protection legislation, including measures for
                                            segregation and encryption of data, will be adopted, to decrease the possibility of unauthorized
                                            access and use. Third parties involved in data transmission, other than your doctor or health care
                                            professional as well as the researchers employed by FullDNA, will not have the means to decrypt your
                                            data, if encrypted.</p>
                                        <h1 className='font-bold mt-2'>DATA CONTROLLER AND DATA PROCESSOR</h1>
                                        <p className='mt-2'>For the purposes of this Consent Form, FullDNA shall act as data processor for the purpose of
                                            providing your report analysis, as well as a controller with respect to the research and other purposes
                                            set forth herein.</p>
                                        <h1 className='font-bold mt-2'>CATEGORIES OF PERSONS IN CHARGE OF THE PROCESSING</h1>
                                        <p className='mt-2'>Physicians, researchers, and administrative personnel subject to professional secrecy obligations may
                                            process the data, each within their respective competences. The data controller and the data
                                            processor indicated in this information document may also entrust their respective personnel,
                                            collaborators, contractors and other third parties that may perform on their behalf and under their
                                            supervision supporting services for the processing of the data. The genetic samples may be
                                            transferred to certified labs, unless this has already been performed and you have consented to
                                            provide us with the results of this process.</p>
                                        <h1 className='font-bold mt-2'>SUB-PROCESSOR</h1>
                                        <p className='mt-2'>Your data may be also processed by sub-processors engaged by FullDNA. FullDNA will ensure that
                                            any processing of your data by such sub-processors will be subject to data processing agreements
                                            ensuring your rights under applicable data protection laws. Should you wish to obtain more
                                            information on such sub-processors, please contact FullDNA using the contact details below.</p>
                                        <h1 className='font-bold mt-2'>DURATION OF PROCESSING</h1>
                                        <p className='mt-2'>Your data will be processed for as long as the research and analysis of your data is required by FullDNA
                                            for the purposes set forth herein. In the event that you request FullDNA NOT to retain data, then such
                                            data will be deleted within thirty days of receiving such a request.</p>
                                        <h1 className='font-bold mt-2'>EXERCISE OF RIGHTS</h1>
                                        <p className='mt-2'>You are entitled, inter alia, to the following rights:
                                            Request the following information: origin of the data; purposes and modalities of processing;
                                            identifying information of the data controller and data processors; persons or categories of persons
                                            to whom the data may be communicated or that may access the data as data processors or persons
                                            in charge of the processing; request the update, correction or integration of your data; request the
                                            cancellation, anonymization or block of your data without prejudice to the rights and obligations to
                                            retain the data provided by law.</p>
                                        <h1 className='font-bold mt-2'>FULLDNA CONFIDENTIALITY</h1>
                                        <p className='mt-2'>After testing, the remaining sample of the extracted DNA will not be available for removal, referral to
                                            another institution, or for further testing.</p>
                                        <p className='mt-2'>The test results will be transcribed in report form and sent to the test requester or his/her physician,
                                            who will be in charge of transmitting it and taking questions. The test results will not, in any case, be
                                            verbally informed. Therefore, in addition to you, only your doctor or health care professional will have
                                            access to the information. Your report is confidential and may not be disclosed to any other institution
                                            or individual without specific written permission.</p>
                                        <p className='mt-2'><span className='font-bold'>Consent (*)</span> Mandatory completion<br />
                                            I confirm that this test is medically necessary for the diagnosis or detection of a disease, pathology,
                                            deficiency, syndrome or disorder and that this result will be used for the purposes and in the manner
                                            as described above.
                                            The risks, benefits and limitations of FullDNA’s Analysis have been explained to me broadly, clearly
                                            and satisfactorily. I declare that I have understood all the terms used and information provided in this
                                            consent form. My signature on this document constitutes permission to perform genetic testing on
                                            a DNA sample taken from me or from a person under my legal custody, indicated above.
                                            I am aware that the analysis of the sample containing genetic material will only begin with the prior
                                            written authorization in this term.</p>
                                            <div className="flex flex-col gap-2">
      {/* Hidden file input */}
      <input
  id="file-upload"
  type="file"
  accept="image/*,.pdf,.doc,.docx"
  className="hidden"
  onChange={(e) => handleFileChange(e)}
/>


      {/* Styled upload label */}
      <label
        htmlFor="file-upload"
        className="inline-block cursor-pointer bg-purple-600 text-white px-4 py-2 rounded-md hover:bg-purple-700 transition"
      >
        Upload Your Signature
      </label>

      {/* Show selected file name */}
      {signatureFile && (
        <span className="text-sm text-white-700">
          Selected file: <span className="font-medium">{signatureFile.name}</span>
        </span>
      )}
    </div>

                                        <p className='mt-2'>PHYSICIAN: Dr Roberto Grobman<br />
                                            According to our GDPR compliance policy, you have the right to keep your data anonymous for
                                            research and statistics purposes. Please select if you want to keep your records <span className='font-bold'>without</span> your name
                                            and any other details related to you.</p>
                                    </div>
                                </div>
                                <div className='mt-2'>
                                    <div className='flex gap-2 items-start'>
                                        <input type='checkbox' className='mt-1' checked={checkboxes[0]} onChange={() => handleCheckboxChange(0)} />
                                        YES, I agree to keep my information anonymously for research & Statistics purposes.
                                    </div>
                                    <div className='flex gap-2 items-start'>
                                        <input type='checkbox' className='mt-1' checked={checkboxes[1]} onChange={() => handleCheckboxChange(1)} />
                                        YES, I agree to keep my information anonymously for my future panel request tests.
                                    </div>
                                    <div className='flex gap-2 items-start'>
                                        <input type='checkbox' className='mt-1' checked={checkboxes[2]} onChange={() => handleCheckboxChange(2)} />
                                        NO, I do not wish to keep my record...
                                    </div>
                                </div>
                                <div className='flex justify-center mt-4'>
                                    <button type='button' onClick={() => { handleConsent() }} className='border rounded-full px-5 py-1 cursor-pointer font-semibold'>I Consent</button>
                                </div>
                            </div>
                            ) : ""
                        }
                        {activeSection === 'div2' && !FormSaved ?  (
                            <div>
                                <h1 className='text-lg text-center font-bold'>Give maximum response as possible for detailed report</h1>
                                <div className='max-h-[50vh] lg:max-h-[45vh] mt-1 Terms-scrollbar overflow-y-auto pr-3'>
                                {AssessmentData.map((section, sectionIndex) => (
                                    <div key={sectionIndex}>
                                        <div className='bg-[#D9D9D9]/10 rounded py-2 px-5'>
                                        {section.sectionTitle}
                                        </div>

                                        {section.questions.map((q, qIndex) => (
                                        <div key={qIndex} className='mb-5'>
                                            <h1 className='px-5 mt-3 mb-2'>{q.question}</h1>
                                            <Select
                                            className='outline-none w-[100%] rounded-full'
                                            options={q.options.map(opt => ({ value: opt, label: opt }))}
                                            placeholder='Select an option'
                                            styles={AllOptionStyle}
                                            isSearchable={false}
                                            value={
                                                answers[q.state_index]
                                                ? { value: answers[q.state_index], label: answers[q.state_index] }
                                                : null
                                            }
                                            onChange={(selected) => handleAnswerChange(q.state_index, selected?.value || '')}
                                            />
                                        </div>
                                        ))}
                                    </div>
                                    ))}

                                </div>

                                <div className='flex justify-center mt-4'>
                                    <button type='button' disabled={isASubmit} onClick={handleSubmit} className='border rounded-full px-5 py-1 cursor-pointer font-semibold'>
                                    {isASubmit ? (
                                        <FontAwesomeIcon icon={faSpinner} spin />
                                    ) : (
                                        <>
                                            Submit Form <FontAwesomeIcon icon={faArrowRight} />
                                        </>
                                    )}
                                    </button>
                                </div>
                                </div>
                        ):""}
                       

                        
                       
                        {activeSection === 'div3' && <ReportProgress />}

                    </div>
                </div>
            )
            }
           
        </div >
       
    );
}
